module.exports = __webpack_public_path__ + "img/focus-bg.589f67c2.png";